import { render } from "./SettingsSetup.vue?vue&type=template&id=1665b0cd"
import script from "./SettingsSetup.vue?vue&type=script&lang=js"
export * from "./SettingsSetup.vue?vue&type=script&lang=js"

import "./SettingsSetup.vue?vue&type=style&index=0&id=1665b0cd&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__